export const problems = [
  {
    "title": "You found activities, but no sequence",
    "text": "You have a few drills saved. Turning them into twelve connected lessons still takes planning."
  },
  {
    "title": "Shared rackets need clear roles",
    "text": "Without a feeder, hitter and swap routine, a class can turn into a queue."
  },
  {
    "title": "Beginners struggle to make contact",
    "text": "A rally may be too much at first. You need small, achievable steps and a clear correction."
  },
  {
    "title": "Mixed levels in the same lesson",
    "text": "Some learners need a closer target. Others are ready to aim farther. One session has to support both."
  },
  {
    "title": "Not sure what comes next",
    "text": "After grip and tapping, how do you build toward serves, rallies and adapted games?"
  },
  {
    "title": "Badminton is new to you",
    "text": "You need practical teaching cues, setup diagrams and an easy way to see who is improving."
  }
];
